import { render, staticRenderFns } from "./shouhou-steps2.vue?vue&type=template&id=070cebb9&scoped=true"
import script from "./shouhou-steps2.vue?vue&type=script&lang=js"
export * from "./shouhou-steps2.vue?vue&type=script&lang=js"
import style0 from "./shouhou-steps2.vue?vue&type=style&index=0&id=070cebb9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070cebb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070cebb9')) {
      api.createRecord('070cebb9', component.options)
    } else {
      api.reload('070cebb9', component.options)
    }
    module.hot.accept("./shouhou-steps2.vue?vue&type=template&id=070cebb9&scoped=true", function () {
      api.rerender('070cebb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformOrderManagement/components/shouhou-steps2.vue"
export default component.exports